import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    isShowWelcomeMessage: false,
  },
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setIsShowWelcomeMessage: (state, action) => {
      state.isShowWelcomeMessage = action.payload;
    },
  },
});

export const { setIsAuthenticated, setIsShowWelcomeMessage } =
  authSlice.actions;

export default authSlice.reducer;
